import { type Atom, useAtomValue } from "jotai";
import { useMemo } from "react";

export function useMemoAtomValue<T>(creator: () => Atom<T>, deps: any[]) {
  return useAtomValue(useMemo(creator, deps));
}
